import React, { Component } from 'react';
import ProductsList from '../ProductsList';
import PostList from '../PostList';
import { withRouter } from 'react-router'
import Post from '../Post';
import URI from '../../constants/serverUrl';
import NewsCard from '../NewsComponents/NewsCard';
import NewsArticle from '../NewsComponents/NewsArticle';

import SmallCard from '../SmallCard/SmallCard';
import HeaderSmall from '../HeaderSmall/HeaderSmall';
const formatDate = (date) => {
      const d = new Date(date);
      return d.getDate() + " " + d.toLocaleString('default', { month: 'long' }) + " " + d.getFullYear();
    }

class News extends Component {

  renderPost = (post) => {
    return (<div>
      <HeaderSmall title="News" />
      <NewsArticle title={post.title}
        date={formatDate(post.created_at)}
        author={post.author || ""}
        image={URI + post.image}
        content={post.content} />
    </div>);
  }

  render() {
    const { posts } = this.props;
    const postId = this.props.post;
    console.log("Post ID:", postId, posts);
    if(postId) {
      const post = posts.find(p => p.id == postId);
      if(post) {
        return this.renderPost(post);
      }
    }
    const extraposts = [...posts];
    /* get the date "2022-09-06T00:38:09.707021Z" formatted like 25January */

    //sort the posts by date latest first
    extraposts.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    const cards = extraposts.map(p => ({
      title: p.title,
      image: URI + p.image,
      date: formatDate(p.created_at),
      id: p.id
    }));
    
    return (
      <div>
        <HeaderSmall title="News" />
        <div className="container py-4">
          <div className="row g-4 pt-4 pl-4 pb-0">
            <div className="col">
              <h1 className='myheadingnews' style={{color: "#5F259F"}}>
                Latest News
              </h1>
            </div>
          </div>
          <div className="row p-4 pt-0">
            {cards.map((card, index) => (
                <NewsCard title={card.title} image={card.image} date={card.date} id={card.id} />
              ))}
          </div>
        </div>
      </div>
      
    );
  }

}

export default withRouter(News);



// WEBPACK FOOTER //
// src/components/pages/News.js